<template lang="pug">
.back-slide-page
  sys-bar(:backable="true" ref="sysBar")
  .content-wrapper(ref="content")
    transition-slide
      slot
</template>
<script>
import SysBar from '@/components/SysBar'
import TransitionSlide from '@/components/TransitionSlide'
export default {
  name: 'BackSlidePage',
  components: { TransitionSlide, SysBar },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    init() {
      this.$refs.content.style.height =
        window.innerHeight -
        this.$refs.sysBar.$el.getBoundingClientRect().height +
        'px'
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.back-slide-page
  +full
  .content-wrapper
    position: relative
</style>
